import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'router'
import { useUser } from 'store'

import ContentProjects from './Content/Projects'
import ContentHome from './Content/Home'
import HeaderBar, { Breadcrumbs, Links } from './components/HeaderBar'
import useContent from './Content/use-content'
import { supportsCompleteDetails } from 'pages/Supervision/Body/Infras/hardware-types'
import { canUseCompleteHardwareView } from 'pages/Supervision/Body/Infras/use-hardware-view-mode'



const Header = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [user] = useUser()
  const { category, links } = useContent()
  const hardwareDetailMatch = location.pathname.match(/^\/monitoring\/infras\/(?:hardwares\/([^/]+)|[^/]+\/([^/]+))\/[^/]+/)
  const detailHardwareType = hardwareDetailMatch?.[1] || hardwareDetailMatch?.[2]
  const isCompleteHardwareDetailPage = canUseCompleteHardwareView(user)
    && supportsCompleteDetails(detailHardwareType)
    && searchParams.get('view') !== 'simple'

  if (!category) return <h1>Aucun menu trouvé</h1>
  if (category.key === 'projects') {
    return <ContentProjects />
  } else if (category.key === 'dashboard') {
    return <ContentHome />
  }

  return (
    <HeaderBar
      title={t(category.label)}
      fallbackBreadcrumbLabel={t(category.label)}
      rightContent={isCompleteHardwareDetailPage ? null : undefined}
    >
      {!isCompleteHardwareDetailPage && links.length > 0 && (
        <Breadcrumbs>
          <Links
            links={links}
            onClick={link => {
              if (link.url) {
                navigate(link.url)
              }
            }}
          />
        </Breadcrumbs>
      )}
    </HeaderBar>
  )
}

export default Header